import { render, staticRenderFns } from "./unSaveDialog.vue?vue&type=template&id=4d108548&scoped=true&"
import script from "./unSaveDialog.vue?vue&type=script&lang=js&"
export * from "./unSaveDialog.vue?vue&type=script&lang=js&"
import style0 from "./unSaveDialog.vue?vue&type=style&index=0&id=4d108548&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d108548",
  null
  
)

export default component.exports